import React, { Component, useEffect, useState } from 'react';
import {
  Layout, Menu, Divider, PageHeader, Row, Col, Grid
} from 'antd';
import 'antd/dist/antd.css';
import { useSelector } from 'react-redux';
import _ from 'lodash'
// import { Redirect } from "react-router-dom";

// import * as Service from './core/Service';

import AppHeader from './AppHeader';
import AppDrawer from './AppDrawer';
import AppFooter from './AppFooter';

import TNContent from './TNContent';
import { COLOR } from '../constants';


const { Content } = Layout;
const { useBreakpoint } = Grid;

const AppLayout = (props) => {
  const {
    children,
    noSidebar,
    title,
    errorRedirect,
    backgroundStyle,
    containerStyle,
  } = props;
  const app = useSelector((state) => state.app)
  const screens = useBreakpoint();
  const isMobile = !screens.lg

  return (
    <Layout>
      <TNContent fullWidth>
        <Row justify="start" style={{ ...backgroundStyle }}>
          <Col span={24}>
            <AppHeader />
          </Col>
          <Col xs={24} sm={24} md={24} lg={24}>
            <div style={{
              minHeight: '100vh',
              // maxWidth: 1100,
              margin: 'auto',
              // padding: isMobile ? '0 20px' : 0,
              ...containerStyle
            }}
            >
              <Row>
                <Col span={24}>
                  <div style={{ minHeight: '70vh' }}>{children}</div>
                </Col>
              </Row>
            </div>
            <section style={{ background: '#000' }}><AppFooter /></section>
          </Col>
        </Row>
      </TNContent>
      <AppDrawer />
    </Layout>
  );
}

export default AppLayout;
